module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-tokai-3-f7c645e2bac9ee1929c6f5d7cf33f27e.jpg";